import DashboardService from '@/client/services/api/DashboardService';
import { useAuthStore } from '@/client/services/state/authStore';
import { useQuery } from '@tanstack/react-query';

export const useGetUserWorkshops = () => {
  const { authConfig } = useAuthStore();
  const { user } = authConfig;

  return useQuery({
    queryKey: ['user-workshops', user._id],
    queryFn: () => DashboardService.getUserWorkshops(user._id),
  });
};
